import React from 'react';
import { format } from 'date-fns';
import { Tooltip } from '@dealroadshow/uikit/core/components/Tooltip';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { MONTH_DASH_YEAR_FORMAT, MONTH_DAY_YEAR_FORMAT } from '@/Framework/dateHelpers/dateFormats';
import ICellProps, { ITranchRow } from './ICellProps';
import { deprecatedParseLegacyDateString } from '@/Framework/dateHelpers/parseDateString';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

const getCell = ({ row: { maturityDate } } : ITranchRow) => (
  maturityDate
      ? format(
          deprecatedParseLegacyDateString(maturityDate.dateTime, maturityDate.timezone.timeZone),
          MONTH_DASH_YEAR_FORMAT,
      )
    : '-'
);

const MaturityCell = ({ rowIndex, tranche } : ICellProps) => {
  const { maturityDate } = tranche;

  if (maturityDate) {
    return (
      <Tooltip
        disabled={ !maturityDate }
        content={ format(
            deprecatedParseLegacyDateString(maturityDate.dateTime, maturityDate.timezone.timeZone),
            MONTH_DAY_YEAR_FORMAT,
        ) }
      >
        <BodyCell
          name="MaturityCell"
          className={ alignStyles.alignCenter }
          rowIndex={ rowIndex }
          rowData={ tranche }
          cellCallback={ getCell }
        />
      </Tooltip>
    );
  }
  return (
    <BodyCell
      name="MaturityCell"
      className={ alignStyles.alignCenter }
      rowIndex={ rowIndex }
      rowData={ tranche }
      cellCallback={ getCell }
    />
  );
};

export default MaturityCell;
